<template>
  <div>
    <slot
      name="element"
      :onClick="fetchTrainingCertificate"
      :loading="loading"
    />

    <!--    <v-dialog
      v-if="trainingCertificate"
      v-model="downloadTrainingCertificateDialog"
      :width="previewTrainingCertificateHeight * 3"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card flat color="grey" class="mouse-cursor">
        <v-toolbar>
          <v-btn icon @click="downloadTrainingCertificateDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>
            {{ $t("user.profile.downloadCertificate") }}
          </v-toolbar-title>

          <v-spacer />

          <v-toolbar-items v-if="downloadTrainingCertificateHtml">
            <v-btn
              icon
              :loading="downloadTrainingCertificateLoading"
              @click="downloadTrainingCertificateAsPdf"
            >
              <v-icon> mdi-file-pdf-box </v-icon>
            </v-btn>

            <v-btn
              icon
              :loading="downloadTrainingCertificateLoading"
              @click="downloadTrainingCertificateAsImage"
            >
              <v-icon> mdi-image </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card
          v-if="downloadTrainingCertificateHtml"
          flat
          color="grey"
          :min-height="previewTrainingCertificateHeight"
          class="py-6 rounded-0"
        >
          <div
            style="display: flex; flex-direction: column; align-items: center"
          >
            <div v-html="downloadTrainingCertificateHtml"></div>
          </div>
        </v-card>
      </v-card>
    </v-dialog>-->

    <v-snackbar
      :value="snackbarError"
      @input="resetSnackbar"
      timeout="3000"
      color="error"
    >
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="resetSnackbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { doQuery } from "@/app/core-module/util/graphqlHelper";
import { bulkDownloadTrainingCertificates } from "@/app/user-module/helpers/certificateHelper";

export default {
  name: "CourseCertificateDownloadDialog",
  props: {
    trainingRegistration: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      snackbarError: false,
      snackbarErrorMessage: null,
      trainingCertificate: null,
      /*downloadTrainingCertificateDialog: false,
      downloadTrainingCertificateLoading: false,
      downloadTrainingCertificateHeight: 600,
      trainingCertificateAspectRatio: 1.41,*/
    };
  },
  computed: {
    /*previewTrainingCertificateHeight() {
      const lowestSize = Math.min(
        this.$vuetify.breakpoint.width,
        this.$vuetify.breakpoint.height
      );

      const relativeHeight =
        (lowestSize * 0.8) / this.trainingCertificateAspectRatio;

      return Math.min(300, relativeHeight);
    },
    downloadTrainingCertificateHtml() {
      return getTrainingCertificateHtmlTemplate({
        trainingCertificate: this.trainingCertificate,
        height: this.previewTrainingCertificateHeight,
      });
    },*/
  },
  methods: {
    resetSnackbar() {
      this.snackbarError = false;
      this.snackbarErrorMessage = null;
    },
    async fetchTrainingCertificate() {
      if (this.loading) return;
      this.loading = true;

      const trainingCertificates = await doQuery({
        query: require("../api/query/getTrainingCertificate.gql"),
        variables: { id: this.trainingRegistration._id },
      }).then(response => {
        if (response?.data?.getTrainingCertificate) {
          return [response.data.getTrainingCertificate];
        }
      });

      const subscriberInfo = await doQuery({
        query: require("../../user-module/api/query/getSubscriberProfile.gql"),
      }).then(response => {
        if (response?.data?.getSubscriberProfile) {
          return response.data.getSubscriberProfile;
        }
      });

      if (trainingCertificates && subscriberInfo) {
        await bulkDownloadTrainingCertificates({
          trainingCertificates,
          subscriberInfo,
        });

        this.loading = false;
      } else {
        this.snackbarError = true;
        this.loading = false;
      }
    },
    /*previewTrainingCertificate() {
      if (this.downloadTrainingCertificateDialog) return;
      this.downloadTrainingCertificateDialog = true;
    },
    async downloadTrainingCertificateAsPdf() {
      if (this.downloadTrainingCertificateLoading) return;
      this.downloadTrainingCertificateLoading = true;

      await this.downloadHtmlAsPdf({
        imageWidth:
          this.downloadTrainingCertificateHeight *
          this.trainingCertificateAspectRatio,
        imageHeight: this.downloadTrainingCertificateHeight,
        imageScaling: 6,
        data: {
          htmlElement: document.getElementById(
            "training-certificate-front-back"
          ),
          elementId: "training-certificate-front-back",
          fileName: `certificate-${
            this.trainingCertificate.certificateNumber
          }-${Date.now()}`,
        },
        orientation: "landscape",
      });

      this.downloadTrainingCertificateLoading = false;
    },
    async downloadTrainingCertificateAsImage() {
      if (this.downloadTrainingCertificateLoading) return;
      this.downloadTrainingCertificateLoading = true;

      await this.downloadHtmlAsImage({
        imageWidth:
          this.downloadTrainingCertificateHeight *
          this.trainingCertificateAspectRatio,
        imageHeight: this.downloadTrainingCertificateHeight,
        imageScaling: 2,
        dataList: [
          {
            htmlElement: document.getElementById(
              "training-certificate-front-back"
            ),
            elementId: "training-certificate-front-back",
            fileName: `certificate-${
              this.trainingCertificate.certificateNumber
            }-${Date.now()}`,
          },
        ],
      });

      this.downloadTrainingCertificateLoading = false;
    },*/
  },
};
</script>

<style scoped></style>
